<script setup>
import MaterialTag from '@/components/create/material/MaterialTag.vue';

const props = defineProps({
  assets: Array,
});

const emit = defineEmits(['click', 'remove', 'update']);

function removeAsset(asset) {
  emit('remove', asset.id);
}

function updateAsset(id, tag) {
  emit('update', id, tag);
}
</script>

<template>
  <div class="flex flex-wrap gap-2" @click="emit('click')">
    <MaterialTag
      v-for="asset in assets"
      :key="asset.id"
      :asset="asset"
      @update="updateAsset"
      @remove="removeAsset"
    />
  </div>
</template>
